import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import { getFeedbackTypeList } from '../../../../constants/constants';
import API_Routes from '../../../../constants/api-routes';
import { useCallback } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
const ModalBody = ({ open, handleClose , handleModalValue}) => {
  const [inputValue, setInputValue] = useState('');
  const [feedbackType, setFeedbackType] = useState('GENERAL QUERY');
  const roles = useSelector(state => state.role);
  const [payload, setPayload] = useState({
    "serviceId": roles.userCurrRole.id,
  });
  const { csrfHeaderName, csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  const { i18n, t } = useTranslation();
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': csrfToken,
  };
  handleModalValue(feedbackType);
  const handleFeedbackChange = (event) => {
    setFeedbackType(event.target.value);
    handleModalValue(event.target.value);
  };

  const handleSubmit = () => {
    // Handle the form submission logic, including the selected feedback type
    console.log('Selected Feedback Type:', feedbackType);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  // const getConsentList = useCallback(() => {
  //   axios.post("http://localhost:8082/cchp/spoc/dashboard/get-consent-list", "", {
  //       withCredentials: true,
  //       headers
  //   })
  //       .then((data) => {
  //           console.log("hi");
  //           console.log(data.data);

  //       })
  //       .catch((error) => {
  //           console.log(error);
  //       });
  // });


  const handleOkClick = () => {
    console.log('Input value:', inputValue);
    handleClose();
  };

  const handleCancelClick = () => {
    // Handle the "Close" button click logic here
    handleClose();
  };

  const handleCloseModal = (event, reason) => {
    if (reason && reason === "backdropClick")
      return;
    handleClose();
  }

  return (
    <Modal open={open} onClose={handleCloseModal}>
      <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', border: '2px solid #000', p: 2 }}>
        <Typography variant="h6" component="div">
          {t('general.model.lable.tryToLog')}
        </Typography>
        <div>
          <div>
            <input
              type="radio"
              id="query"
              name="feedbackType"
              value='GENERAL QUERY'
              checked={feedbackType === 'GENERAL QUERY'}
              onChange={handleFeedbackChange}
            />
            <label htmlFor="query">{t('general.model.lable.isNotComplaint')}</label>
          </div>
          <div>
            <input
              type="radio"
              id="complaint"
              name="feedbackType"
              value='COMPLAINT'
              checked={feedbackType === 'COMPLAINT'}
              onChange={handleFeedbackChange}
            />
            <label htmlFor="complaint">{t("general.model.lable.isComplaint")}</label>
          </div>
        </div>
        <Box mt={1} display="flex" justifyContent="flex-end">
          <Button variant="contained" onClick={handleOkClick} >
            {t('general.button.ok.label')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalBody;
